import { create } from 'zustand';

interface HeaderState {
  isHeaderVisible: boolean;
  isFitToScreen: boolean;
  toggleHeader: () => void;
  setHeaderVisibility: (isVisible: boolean) => void;
  toggleFitToScreen: () => void;
  setFitToScreen: (fitToScreen: boolean) => void;
}

export const useHeaderStore = create<HeaderState>((set) => ({
  isHeaderVisible: true,
  isFitToScreen: false,
  toggleHeader: () => set((state) => ({ isHeaderVisible: !state.isHeaderVisible })),
  setHeaderVisibility: (isVisible) => set({ isHeaderVisible: isVisible }),
  toggleFitToScreen: () => set((state) => ({ isFitToScreen: !state.isFitToScreen })),
  setFitToScreen: (fitToScreen) => set({ isFitToScreen: fitToScreen }),
}));
